import React, { memo } from "react";
import { Step } from "@mui/material";

import StepLabel from "../StepLabel/StepLabel";
import CustomStepIcon from "./components/CustomStepIcon";
import { StyledStepButton, StyledLabel } from "./StepItem.styled";

import {
  useMultistepFormStore,
  CustomFormSectionDto,
} from "@components/common/MultistepForm";
import { Stack } from "@components/base";

interface StepItem {
  section: CustomFormSectionDto;
  sectionIndex: number;
}

const StepItem: React.FC<StepItem> = memo(({ section, sectionIndex }) => {
  const { activeSection, setActiveSection } = useMultistepFormStore();

  const handleClick = (): void => {
    setActiveSection(section);
  };

  return (
    <Step
      key={`step-item-${section.id}`}
      sx={{ opacity: section.isMatchingQuery ? 1 : 0.5 }}
    >
      <StyledStepButton onClick={handleClick}>
        <StyledLabel
          StepIconComponent={CustomStepIcon}
          StepIconProps={{
            active: activeSection?.id === section.id,
            completed: section.isCompleted,
            icon: sectionIndex + 1,
          }}
          sx={{ width: "100%" }}
        >
          <Stack direction="row" spacing={1}>
            <StepLabel section={section} active={activeSection?.id === section.id} />
          </Stack>
        </StyledLabel>
      </StyledStepButton>
    </Step>
  );
});

export default StepItem;
